import React, { useEffect, useState } from "react";
import {
    Row,
    Col,
    Card,
    Button,
    notification,
    Form,
    Select,
    Input,
} from "antd";
import apiClient from "../../services/api";
import { useNavigate, useParams } from "react-router-dom";
import JoditEditor from "jodit-react";
import { handleApiError, handleApiSuccess, handleApiInfo } from "../../utils/errorHandler";
import logger from "../../utils/logger";

const { Item } = Form;
const { Option } = Select;

function BlogForm() {
    const { blogId } = useParams(); // Extract reportElementId from URL
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [isUpdateMode, setIsUpdateMode] = useState(false);
    const [bannerImage, setBannerImage] = useState('');
    const [selectedPage, setSelectedPage] = useState('');
    const [selectedBannerImage, setSelectedBannerImage] = useState(null)

    useEffect(() => {
        // Check if reportElementId exists to determine if it's an update mode
        if (blogId) {
            setIsUpdateMode(true);
            fetchDetails();
        }
    }, [blogId, form]);

    const fetchDetails = async () => {
        try {
            const response = await apiClient.get(`/api/blog/${blogId}`);
            if (response.status === 200) {
                setSelectedPage(response.data.result.page);
                setSelectedBannerImage(response?.data?.result?.bannerImage || null);
                form.setFieldsValue(response.data.result);
            } else {
                handleApiInfo(response.data.message);
            }
        } catch (error) {
            handleApiError(error);
            logger.error("API error:", error);
        }
    };

    const onFinish = async (values) => {
        try {
            let formData = new FormData();
            for (let key in values) {

                formData.append(key, values[key]);
            }
            if (bannerImage) {
                formData.append('file', bannerImage);
            }

            if (isUpdateMode) {
                formData.append('id', blogId);
                const response = await apiClient.patch('/api/blog', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.status === 200) {
                    handleApiSuccess('Blog updated successfully!');
                    navigate('/blog-management');
                } else {
                    handleApiInfo(response.data.message);
                }
            } else {
                const response = await apiClient.post('/api/blog', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.status === 200) {
                    handleApiSuccess('Blog added successfully!');
                    form.resetFields();
                    navigate('/blog-management');
                } else {
                    handleApiInfo(response.data.message);
                }
            }
        } catch (error) {
            handleApiError(error);
            logger.error("API error:", error);
        }
    };

    function bannerImageSelect(brandLogo) {
        setBannerImage(brandLogo);
    }

    return (
        <div className="tabled">
            <Row gutter={[24, 0]}>
                <Col xs="24" xl={24}>
                    <Card
                        bordered={false}
                        className="criclebox tablespace mb-24"
                        title={isUpdateMode ? "Update Blog Management" : "Add Blog Management"}
                    >
                        <Form style={{ "padding": "20px" }} form={form} onFinish={onFinish} layout="vertical">
                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={12} lg={12}>
                                    <Item
                                        label="Title"
                                        name="title"
                                        rules={[{ required: true, message: 'Please enter title.' }]}
                                    >
                                        <Input placeholder="Please enter title" />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={12}>
                                    <Item
                                        label="Slug"
                                        name="slug"
                                        rules={[{ required: true, message: 'Please enter slug.' }]}
                                    >
                                        <Input placeholder="Please enter slug" />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={12}>
                                    <Item
                                        label="Type"
                                        name="type"
                                        rules={[{ required: false, message: 'Please enter page title.' }]}
                                    >
                                        <Input placeholder="Please enter type" />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={12}>
                                    <Item
                                        label="Banner Image"
                                    >
                                        <Input type="file" onChange={(e) => bannerImageSelect(e.target.files[0])} />
                                    </Item>
                                    {selectedBannerImage &&
                                        <img width={500} height={150} src={selectedBannerImage} />
                                    }
                                </Col>
                                <Col xs={24} sm={12} lg={12}>
                                    <Item
                                        label="Short Content"
                                        name="shortContent"
                                        rules={[{ required: false, message: 'Please enter short content.' }]}
                                    >
                                        <JoditEditor />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={24} lg={24}>
                                    <Item
                                        label="Content"
                                        name="content"
                                        rules={[{ required: true, message: 'Please enter content.' }]}
                                    >
                                        <JoditEditor />
                                    </Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={24} sm={12} lg={8}>
                                    <Item>
                                        <Button type="primary" htmlType="submit">
                                            {isUpdateMode ? "Update" : "Add"}
                                        </Button>
                                    </Item>
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}

export default BlogForm;
